<div *ngIf="isOpen"
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4"
  (click)="onBackdropClick()">
  <div
    class="bg-white rounded-3xl max-w-sm w-full shadow-2xl overflow-hidden transform transition-all duration-300"
    (click)="$event.stopPropagation()">

    <!-- Top accent bar -->
    <div class="h-1.5 w-full bg-gradient-to-r from-[#D31148] to-[#ff6b9d]"></div>

    <div class="px-7 py-7">

      <!-- Icon -->
      <div class="flex justify-center mb-5">
        <div class="w-16 h-16 rounded-full bg-[#FFF0F3] flex items-center justify-center">
          <ng-container [ngSwitch]="icon">

            <svg *ngSwitchCase="'lock'" width="32" height="32" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="11" width="18" height="11" rx="2" stroke="#D31148" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="#D31148" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <svg *ngSwitchCase="'user-add'" width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                stroke="#D31148" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <circle cx="9" cy="7" r="4"
                stroke="#D31148" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <line x1="19" y1="8" x2="19" y2="14" stroke="#D31148" stroke-width="2" stroke-linecap="round" />
              <line x1="22" y1="11" x2="16" y2="11" stroke="#D31148" stroke-width="2" stroke-linecap="round" />
            </svg>

            <svg *ngSwitchCase="'heart'" width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                stroke="#D31148" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <svg *ngSwitchCase="'warning'" width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                stroke="#D31148" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <line x1="12" y1="9" x2="12" y2="13" stroke="#D31148" stroke-width="2" stroke-linecap="round" />
              <line x1="12" y1="17" x2="12.01" y2="17" stroke="#D31148" stroke-width="2" stroke-linecap="round" />
            </svg>

            <svg *ngSwitchDefault width="32" height="32" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#D31148" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
              <line x1="12" y1="8" x2="12" y2="12" stroke="#D31148" stroke-width="2" stroke-linecap="round" />
              <line x1="12" y1="16" x2="12.01" y2="16" stroke="#D31148" stroke-width="2" stroke-linecap="round" />
            </svg>

          </ng-container>
        </div>
      </div>

      <!-- Title -->
      <h3 class="text-center text-xl font-bold text-gray-900 mb-2">{{ title }}</h3>

      <!-- Message -->
      <p class="text-center text-sm text-gray-500 leading-relaxed mb-7">
        {{ message }}
        <span *ngIf="highlightedName" class="font-bold text-[#D31148]"> {{ highlightedName }}</span>
        <span *ngIf="messageSuffix">, {{ messageSuffix }}</span>
      </p>

      <!-- Buttons -->
      <div class="flex flex-col gap-3">
        <button *ngIf="confirmLabel" (click)="onConfirm()"
          class="w-full py-3 rounded-xl bg-[#D31148] text-white font-semibold text-sm
                 hover:bg-[#b80e3d] active:scale-[0.98] transition-all">
          {{ confirmLabel }}
        </button>
        <button *ngIf="cancelLabel" (click)="onCancel()"
          class="w-full py-3 rounded-xl border border-gray-200 text-gray-600 font-semibold text-sm
                 hover:bg-gray-50 active:scale-[0.98] transition-all">
          {{ cancelLabel }}
        </button>
      </div>

    </div>
  </div>
</div>